import { Helmet } from "react-helmet-async"
import { SupplierList } from "../../../Supplier"
import { FeatureFlag, ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function ActivitySuppliersPage() {
	return (
		<ForbidUnlessAuthorized
			permission={PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS}
		>
			<FeatureFlag flag="travel_activities" show404>
				<Helmet>
					<title>Activity Suppliers</title>
				</Helmet>
				<SupplierList
					title="Activity Suppliers"
					supplierType="travel_activities"
				/>
			</FeatureFlag>
		</ForbidUnlessAuthorized>
	)
}
